import isNullOrEmpty from "../helpers/isNullOrEmpty";
import {ProblemDetails} from "./ProblemDetails.js";

function getErrorTitle(response: Response, problemDetails: ProblemDetails): string {
	const title = isNullOrEmpty(response.statusText) ? (problemDetails.title ?? problemDetails.detail) : response.statusText;
	const type = isNullOrEmpty(problemDetails.type) ? ` (${response.type})` : ` (${response.type}/${problemDetails.type})`;

	if (response.status === 0) {
		if (isNullOrEmpty(response.statusText)) {
			return "Opaque response to no-cors request"
		}

		return `[${type}] - ${title}`;
	}

	if (isNullOrEmpty(title)) {
		return `[${response.status}:${type}]`;
	}

	return `[${response.status}:${type}] - ${title}`;
}

function getErrorMessage(response: Response | null, problemDetails: ProblemDetails): string {
	if (response == null) {
		return "Connection error";

	} else {
		return `${getErrorTitle(response, problemDetails)} @ ${response.url}`
	}
}

class HttpClientError extends Error {
	problemDetails: ProblemDetails;
	request: RequestInit | null | undefined;
	response: Response | null | undefined;

	constructor(problemDetails: ProblemDetails, request: RequestInit | null, response: Response | null) {
		super(getErrorMessage(response, problemDetails));

		this.problemDetails = problemDetails;
		this.request = request;
		this.response = response;
	}

	get status(): number {
		return this.problemDetails.status ?? this.response?.status ?? 0;
	}

	getRequestHeader(headerName: string): string | null {
		let headers = this.request?.headers;
		if (headers == null) {
			return null;
		}

		if (!(headers instanceof Headers)) {
			headers = this.request!.headers = new Headers(headers);
		}

		return headers.get(headerName);
	}
}

export {HttpClientError};
